import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, List } from 'semantic-ui-react';
import { IUser } from '../../../../../shared/User/IUser';
import { IShipment } from '../shared/models/IShipment';

export function IncomingShipment({shipment, user}: { shipment: IShipment, user: IUser }) {
  return <List.Item key={shipment.uuid}>
    <List.Content floated="right">
      <Button as={Link} to={`/shipments/${shipment.uuid}`} size="mini">
        {shipment.isReadOnly ? 'Voir' : 'Réceptionner'}
      </Button>
    </List.Content>
    <List.Icon name="sign in"/>
    <List.Content>
      <List.Header>{shipment.origin}</List.Header>
      <List.Description>
        <small>
          livraison en provenance de {shipment.origin}
        </small>
      </List.Description>
    </List.Content>
  </List.Item>;
}
